class OauthCallbackController {
  constructor(OAuthUserService, tokenService, $stateParams) {
    "ngInject";
    this.userService  = OAuthUserService;
    this.params       = $stateParams;
    this.tokenService = tokenService;
  }
  $onInit() {
    const token = this.params.access_token
    if(!token) {
      return;
    }
    this.tokenService.setToken(token)

    if (this.params.user_show_name) {
      this.tokenService.setDecodedUsername(decodeURI(this.params.user_show_name));
    }
    
    this.userService.login()
  }
}

export default {
  template: "<h1>Redireccionando</h1>",
  controller: OauthCallbackController,
  controllerAs: "opk"
}



// WEBPACK FOOTER //
// ./src/components/oauthCallback.component.js